import { render, staticRenderFns } from "./MpFindWordsByClick.vue?vue&type=template&id=72bbf0de&scoped=true&"
import script from "./MpFindWordsByClick.vue?vue&type=script&lang=js&"
export * from "./MpFindWordsByClick.vue?vue&type=script&lang=js&"
import style0 from "./MpFindWordsByClick.vue?vue&type=style&index=0&id=72bbf0de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bbf0de",
  null
  
)

export default component.exports